/* ============================================================
   mt-wishlist.js - Merkliste / „Gemerkt für später“
   Mathieu's Taverne. Speicherung im localStorage des Browsers. Für angemeldete Kunden gleicht
   assets/mt-portal.js die Liste seit 19.10.2026 über das Kundenportal mit dem Kundenkonto ab
   (Ereignis „mt:merkliste“, siehe write()). Keine App, keine Lizenzkosten.
   Karten: normale Shop-Karte (snippets/mt-landing-pcard über section mt-merkliste-karte), Stil in assets/mt-landing.css.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'mt_wishlist';
  var STUMM = false; // Kundenportal: true, solange eine Liste vom Server übernommen wird
  // Codex-Audit 15.09.2026: englische Storefront erkennen (wie IST_EN in mt-filter.js)
  var IST_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;

  /* ---------- Store ---------- */
  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); }
    catch (e) { /* Speicher voll / privat - still ignorieren */ }
    // Kundenportal (19.10.2026): Änderung melden, mt-portal.js gleicht sie mit dem Kundenkonto ab (nur angemeldet geladen)
    if (!STUMM) { try { document.dispatchEvent(new CustomEvent('mt:merkliste')); } catch (e2) {} }
  }
  function has(list, id) {
    id = String(id);
    for (var i = 0; i < list.length; i++) { if (String(list[i].id) === id) return true; }
    return false;
  }
  function remove(list, id) {
    id = String(id);
    return list.filter(function (it) { return String(it.id) !== id; });
  }

  function itemFromButton(btn) {
    return {
      id: btn.getAttribute('data-id'),
      handle: btn.getAttribute('data-handle') || '',
      title: btn.getAttribute('data-title') || '',
      url: btn.getAttribute('data-url') || '',
      image: btn.getAttribute('data-image') || '',
      price: btn.getAttribute('data-price') || '',
      vendor: btn.getAttribute('data-vendor') || '',
      type: btn.getAttribute('data-type') || ''
    };
  }

  /* ---------- Button-Zustaende ---------- */
  function syncButton(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    /* Codex-Nachtrag 16.09.2026: zugänglicher Name folgt dem Zustand (Merken/Gemerkt, EN aus data-label-*) */
    var lbl = btn.querySelector('.mt-wish-label');
    var nm = lbl ? (on ? (lbl.getAttribute('data-label-on') || 'Gemerkt') : (lbl.getAttribute('data-label-add') || 'Merken')) : (IST_EN ? (on ? 'Saved' : 'Save') : (on ? 'Gemerkt' : 'Merken'));
    btn.setAttribute('aria-label', nm + (btn.getAttribute('data-title') ? ': ' + btn.getAttribute('data-title') : ''));
    btn.classList.toggle('is-on', on);
    var label = btn.querySelector('.mt-wish-label');
    if (label) {
      label.textContent = on
        ? (label.getAttribute('data-label-on') || 'Gemerkt')
        : (label.getAttribute('data-label-add') || 'Merken');
    }
  }
  function syncAllButtons() {
    var list = read();
    var btns = document.querySelectorAll('[data-mt-wish]');
    for (var i = 0; i < btns.length; i++) {
      syncButton(btns[i], has(list, btns[i].getAttribute('data-id')));
    }
  }

  /* ---------- Zaehler (Header o.ae.) ---------- */
  function updateCount() {
    var n = read().length;
    var els = document.querySelectorAll('[data-mt-wish-count]');
    for (var i = 0; i < els.length; i++) { els[i].textContent = n; }
    var wraps = document.querySelectorAll('[data-mt-wish-count-wrap]');
    for (var j = 0; j < wraps.length; j++) {
      wraps[j].classList.toggle('mt-wish-empty', n === 0);
    }
  }

  /* ---------- Toggle ---------- */
  function toggle(btn) {
    // Herz auf einer Karte der Merkliste: wirkt wie „Entfernen“ (Karte bleibt am Platz, mit Rückgängig)
    var mk = btn.closest('#mt-merkliste-grid .mtmk-karte');
    if (mk) { removeWithUndo(mk); return; }
    var list = read();
    var id = btn.getAttribute('data-id');
    var on;
    if (has(list, id)) {
      list = remove(list, id);
      on = false;
    } else {
      list.unshift(itemFromButton(btn));
      on = true;
    }
    write(list);
    // alle Buttons desselben Produkts aktualisieren
    var same = document.querySelectorAll('[data-mt-wish][data-id="' + id + '"]');
    for (var i = 0; i < same.length; i++) {
      syncButton(same[i], on);
      if (on) {
        (function (b) {
          b.classList.add('just-added');
          setTimeout(function () { b.classList.remove('just-added'); }, 380);
        })(same[i]);
      }
    }
    updateCount();
    renderMerkliste();
  }

  /* ---------- Merkliste-Seite rendern ---------- */
  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  // 07.10.2026 (GPT A11-006): Gruppentitel (Produkttyp) auf Englisch, Links in der Sprache der Seite.
  var EN_TYP = {"Artillerie":"Artillery","Bases & Tabletts":"Bases & trays","Basing-Material":"Basing material","Broschüre":"Brochure","Charaktere & Kommando":"Characters & command","Fahnen":"Flags","Fahrzeuge":"Vehicles","Farben":"Paints","Flugzeuge":"Aircraft","Gelände":"Terrain","Gutschein":"Gift card","Infanterie":"Infantry","Kavallerie":"Cavalry","Marker & Token":"Markers & tokens","Panzer":"Tanks","Pinsel":"Brushes","Regelwerk":"Rulebooks","Schiffe":"Ships","Spielmatte":"Gaming mats","Starterarmee":"Starter armies","Starterset":"Starter sets","Streitwagen":"Chariots","Szenario-Buch":"Scenario books","Transport & Aufbewahrung":"Transport & storage","Werkzeug":"Tools","Würfel":"Dice","Zubehör & Bitz":"Accessories & bitz","Sonstige":"Other"};
  function typName(t) { return IST_EN ? (EN_TYP[t] || t) : t; }
  function artikelZahl(n) { return n + (IST_EN ? (n === 1 ? ' item' : ' items') : ' Artikel'); }
  function sprachUrl(u) { if (!u || u.charAt(0) !== '/') return u; var p = u.replace(/^\/en(?=\/|$)/, ''); return (IST_EN ? '/en' : '') + p; }

  /* ---------- Karten der Merkliste = Shop-Karte (GPT A13-004, 07.10.2026) ----------
     Vorher baute diese Datei eine eigene Karte aus den Angaben im Speicher (ohne Lieferstatus, ohne UVP, Preis vom Tag des Merkens).
     Jetzt kommt je Produkt die normale Shop-Karte (snippets/mt-landing-pcard, bk: true) über
     /products/<handle>?section_id=mt-merkliste-karte in der Sprache der Seite, wie bei „Zuletzt angesehen“.
     Preis, UVP, Lieferstatus, Versandzeile und Kaufknopf stammen aus der Karte. Diese Datei ergänzt nur die Herstellerzeile
     (wie die Katalogkarte) und „Entfernen“. Stil der Karte: assets/mt-landing.css, die Zusätze stehen in mt-fixes.css (MT-MERKLISTE-KARTE). */
  var SKRIPT_ADR = (document.currentScript && document.currentScript.src) || '';
  var KARTEN = {};      // handle -> Promise mit { html, typ, hersteller, cent, preis } | { fehlt: true } | null (zurzeit nicht abrufbar)
  var PREIS = {};       // id -> aktueller Preis in Cent (für die Sortierung)
  var WARTE = [], OFFEN = 0;
  var stilDa = null, kaufTimer = null, sortTimer = null;

  function kartenWurzel() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (IST_EN ? '/en/' : '/');
    return r.replace(/\/$/, '');
  }
  function leseKarte(t) {
    if (!t) return { fehlt: true };
    var doc = new DOMParser().parseFromString(t, 'text/html');
    var h = doc.querySelector('[data-mtmk-karte]');
    var k = h && h.querySelector('.pcard');
    if (!k) return { fehlt: true };
    var zeile = k.querySelector('.prow'), pp = k.querySelector('.pp');
    var cent = zeile ? parseInt(zeile.getAttribute('data-preis'), 10) : NaN;
    return {
      html: k.outerHTML,
      typ: h.getAttribute('data-typ') || '',
      hersteller: h.getAttribute('data-hersteller') || '',
      cent: isNaN(cent) ? null : cent,
      preis: pp ? pp.textContent.replace(/\s+/g, ' ').trim() : ''
    };
  }
  // höchstens drei Abrufe gleichzeitig; bei Drosselung (429) oder Netzfehler zwei weitere Versuche
  function pumpe() {
    while (OFFEN < 3 && WARTE.length) {
      (function (a) {
        OFFEN++;
        fetch(kartenWurzel() + '/products/' + encodeURIComponent(a.handle) + '?section_id=mt-merkliste-karte', { credentials: 'same-origin' })
          .then(function (r) { if (r.status === 404) return ''; if (!r.ok) throw 0; return r.text(); })
          .then(function (t) { var d; try { d = leseKarte(t); } catch (e) { d = { fehlt: true }; } OFFEN--; a.fertig(d); pumpe(); }, function () {
            OFFEN--;
            if (a.versuch < 2) { a.versuch++; setTimeout(function () { WARTE.push(a); pumpe(); }, 1500 * a.versuch); }
            else { delete KARTEN[a.handle]; a.fertig(null); }
            pumpe();
          });
      })(WARTE.shift());
    }
  }
  function holeKarte(handle) {
    if (!KARTEN[handle]) {
      KARTEN[handle] = new Promise(function (fertig) { WARTE.push({ handle: handle, fertig: fertig, versuch: 0 }); pumpe(); });
    }
    return KARTEN[handle];
  }
  // Stylesheet der Shop-Karte erst laden, wenn es Karten gibt (wie „Zuletzt angesehen“). Die Adresse steht am Raster (data-karten-css);
  // fehlt sie (Reiter im Konto), wird sie aus der Adresse dieser Datei abgeleitet.
  function kartenStil(grid) {
    if (stilDa) return stilDa;
    stilDa = new Promise(function (ok) {
      var da = document.querySelector('link[rel="stylesheet"][href*="mt-landing.css"]');
      if (da) {
        if (da.sheet) { ok(); return; }
        da.addEventListener('load', ok); da.addEventListener('error', ok); setTimeout(ok, 3000); return;
      }
      var adr = grid.getAttribute('data-karten-css') || (SKRIPT_ADR.indexOf('mt-wishlist.js') > -1 ? SKRIPT_ADR.replace(/mt-wishlist\.js.*$/, 'mt-landing.css') : '');
      if (!adr) { ok(); return; }
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = adr; l.onload = l.onerror = ok;
      document.head.appendChild(l);
      setTimeout(ok, 4000);
    });
    return stilDa;
  }
  function entfernenKnopf(item) {
    var rm = el('button', 'mtmk-weg', IST_EN ? 'Remove' : 'Entfernen');
    rm.type = 'button';
    rm.setAttribute('aria-label', (IST_EN ? 'Remove from wishlist' : 'Von der Merkliste entfernen') + (item.title ? ': ' + item.title : ''));
    rm.setAttribute('data-mk-remove', item.id);
    return rm;
  }
  // Die Shop-Karte, ergänzt um Herstellerzeile und „Entfernen“
  function baueKarte(item, d) {
    var tmp = document.createElement('div');
    tmp.innerHTML = d.html;
    var k = tmp.firstElementChild;
    k.classList.add('mtmk-karte');
    k.setAttribute('data-id', item.id);
    var bd = k.querySelector('.bd'), pt = k.querySelector('.bd > .pt'), fuss = k.querySelector('.pfoot');
    if (d.hersteller && bd && pt) bd.insertBefore(el('span', 'mtmk-hst', d.hersteller), pt);
    (fuss || bd || k).appendChild(entfernenKnopf(item));
    return k;
  }
  // Platzhalter mit den Angaben aus dem Speicher: solange die Karte lädt ('laedt'), oder wenn das Produkt nicht mehr im Shop ist ('fehlt')
  function baueErsatz(item, art) {
    var k = el('div', 'pcard pcard--lp mtmk-karte mtmk-karte--' + art);
    k.setAttribute('data-id', item.id);
    var pim = el('span', 'pim'), im = el('span', 'im');
    if (item.image) {
      var img = document.createElement('img');
      img.alt = ''; img.loading = 'lazy'; img.width = 360; img.height = 360;
      img.onerror = function () { if (img.parentNode) img.parentNode.removeChild(img); };
      img.src = item.image;
      im.appendChild(img);
    }
    pim.appendChild(im);
    k.appendChild(pim);
    var bd = el('div', 'bd');
    if (item.vendor) bd.appendChild(el('span', 'mtmk-hst', item.vendor));
    bd.appendChild(el('span', 'pt', item.title || (IST_EN ? 'Item' : 'Artikel')));
    var fuss = el('div', 'pfoot');
    if (art === 'fehlt') {
      fuss.appendChild(el('span', 'pdeliv mtmk-fehlt-t', IST_EN ? 'Currently unavailable' : 'Zurzeit nicht verfügbar'));
      fuss.appendChild(entfernenKnopf(item));
    } else {
      k.setAttribute('aria-busy', 'true');
    }
    bd.appendChild(fuss);
    k.appendChild(bd);
    return k;
  }
  // Typ (für die Gruppierung, nur wenn er fehlt) und aktuellen Preis (für die Sortierung) im Speicher nachtragen
  function pflegeSpeicher(item, d) {
    if (d.cent != null) PREIS[String(item.id)] = d.cent;
    var l = read(), neu = false;
    for (var i = 0; i < l.length; i++) {
      if (String(l[i].id) !== String(item.id)) continue;
      if (!l[i].type && d.typ && !IST_EN) { l[i].type = d.typ; neu = true; }
      if (d.cent != null && l[i].preis_ct !== d.cent) { l[i].preis_ct = d.cent; neu = true; }
      if (d.preis && !IST_EN && l[i].price !== d.preis) { l[i].price = d.preis; neu = true; }
    }
    if (neu) write(l);
  }
  // Kaufknopf der Karte an den Warenkorb des Themes anbinden (öffnet den Seitenwarenkorb), wie „Zuletzt angesehen“
  function kaufAnbinden() {
    clearTimeout(kaufTimer);
    kaufTimer = setTimeout(function () {
      if (window.ajaxCart && typeof window.ajaxCart.init === 'function') { try { window.ajaxCart.init(); } catch (e) {} }
    }, 60);
  }
  // Sortierung nach Preis: stimmt die Reihenfolge mit den aktuellen Preisen nicht mehr, einmal neu ordnen (Karten liegen dann schon vor)
  function sortPruefen() {
    clearTimeout(sortTimer);
    sortTimer = setTimeout(function () {
      if (WARTE.length || OFFEN) return;
      var s = getSortPref();
      if (s !== 'price-asc' && s !== 'price-desc') return;
      var grid = document.getElementById('mt-merkliste-grid');
      if (!grid || grid.querySelector('.mtmk-karte--undo')) return;
      var soll = {}, l = sortList(read());
      for (var i = 0; i < l.length; i++) { var b = bucketOf(l[i]); (soll[b] = soll[b] || []).push(String(l[i].id)); }
      var gruppen = grid.querySelectorAll('.mtmk-group'), anders = false;
      for (var g = 0; g < gruppen.length && !anders; g++) {
        var ist = [], ks = gruppen[g].querySelectorAll('.mtmk-karte');
        for (var j = 0; j < ks.length; j++) ist.push(ks[j].getAttribute('data-id'));
        if (ist.join('|') !== (soll[gruppen[g].getAttribute('data-typ')] || []).join('|')) anders = true;
      }
      if (anders) renderMerkliste();
    }, 120);
  }
  // Liefert sofort einen Platzhalter und tauscht ihn gegen die Shop-Karte, sobald sie da ist
  function buildCard(item) {
    if (!item.handle) return baueErsatz(item, 'fehlt');
    var ph = baueErsatz(item, 'laedt');
    holeKarte(item.handle).then(function (d) {
      if (!ph.parentNode) return;
      var gut = d && !d.fehlt;
      var k = gut ? baueKarte(item, d) : baueErsatz(item, 'fehlt');
      ph.parentNode.replaceChild(k, ph);
      if (gut) { pflegeSpeicher(item, d); kaufAnbinden(); sortPruefen(); }
    });
    return ph;
  }

  /* ---------- Gruppen nach Produkttyp ---------- */
  function escHtml(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function bucketOf(it) {
    var t = (it && it.type ? String(it.type) : '').trim();
    return t || 'Sonstige';
  }
  function renderMerkliste() {
    var grid = document.getElementById('mt-merkliste-grid');
    if (!grid) return;
    var empty = document.getElementById('mt-merkliste-empty');
    var sortWrap = document.getElementById('mt-merkliste-sortwrap');
    var list = sortList(read());

    grid.innerHTML = '';
    if (!list.length) {
      grid.hidden = true;
      if (empty) empty.hidden = false;
      if (sortWrap) sortWrap.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (sortWrap) sortWrap.hidden = false;
    grid.hidden = false;
    kartenStil(grid).then(function () { grid.classList.add('mtmk-da'); });

    // nach Produkttyp gruppieren
    var groups = {}, order = [];
    for (var i = 0; i < list.length; i++) {
      var b = bucketOf(list[i]);
      if (!groups[b]) { groups[b] = []; order.push(b); }
      groups[b].push(list[i]);
    }
    order.sort(function (a, c) { return a.localeCompare(c, 'de'); });

    var multi = order.length > 1;
    var frag = document.createDocumentFragment();
    for (var g = 0; g < order.length; g++) {
      var name = order[g];
      var items = groups[name];
      var group = el('div', 'mtmk-group');
      group.setAttribute('data-typ', name);
      if (multi) {
        var head = el('div', 'mtmk-group-head');
        head.appendChild(el('h3', 'mtmk-group-title', typName(name)));
        head.appendChild(el('span', 'mtmk-group-count', artikelZahl(items.length)));
        group.appendChild(head);
      }
      // Hülle und Reihe der Shop-Karte (mt-landing.css): vier Karten je Reihe, Tablet drei, Handy zwei
      var huelle = el('div', 'mt-lp mt-lp--einbett mtmk-karten');
      var reihe = el('div', 'lp-prod mtmk-reihe');
      for (var j = 0; j < items.length; j++) { reihe.appendChild(buildCard(items[j])); }
      huelle.appendChild(reihe);
      group.appendChild(huelle);
      frag.appendChild(group);
    }
    grid.appendChild(frag);
  }

  /* ---------- Events ---------- */
  /* ---------- Entfernen mit Inline-Rückgängig (Karte bleibt am Platz) ---------- */
  var undoTimers = {};

  function reconcileMerkliste() {
    var grid = document.getElementById('mt-merkliste-grid');
    if (!grid) return;
    var groups = grid.querySelectorAll('.mtmk-group');
    for (var g = 0; g < groups.length; g++) {
      var cards = groups[g].querySelectorAll('.mtmk-karte');
      if (!cards.length) { if (groups[g].parentNode) groups[g].parentNode.removeChild(groups[g]); continue; }
      var cnt = groups[g].querySelector('.mtmk-group-count');
      if (cnt) cnt.textContent = artikelZahl(cards.length);
    }
    var remain = grid.querySelectorAll('.mtmk-karte');
    if (!remain.length) {
      grid.hidden = true;
      var empty = document.getElementById('mt-merkliste-empty');
      var sortWrap = document.getElementById('mt-merkliste-sortwrap');
      if (empty) empty.hidden = false;
      if (sortWrap) sortWrap.hidden = true;
    }
  }

  function finalizeRemoval(li) {
    li.classList.add('mtmk-fade-out');
    setTimeout(function () {
      if (li.parentNode) li.parentNode.removeChild(li);
      reconcileMerkliste();
    }, 280);
  }

  function restoreCard(li, item, idx) {
    var l = read();
    if (!l.some(function (x) { return String(x.id) === String(item.id); })) {
      l.splice(Math.min(idx < 0 ? l.length : idx, l.length), 0, item);
      write(l);
    }
    var hearts = document.querySelectorAll('[data-mt-wish][data-id="' + item.id + '"]');
    for (var h = 0; h < hearts.length; h++) syncButton(hearts[h], true);
    updateCount();
    var fresh = buildCard(item);
    fresh.classList.add('mtmk-fade-in');
    if (li.parentNode) li.parentNode.replaceChild(fresh, li);
    void fresh.offsetWidth;
    fresh.classList.remove('mtmk-fade-in');
  }

  function removeWithUndo(li) {
    var id = li.getAttribute('data-id');
    var l = read();
    var item = null, idx = -1;
    for (var i = 0; i < l.length; i++) { if (String(l[i].id) === String(id)) { item = l[i]; idx = i; break; } }
    if (!item) { if (li.parentNode) li.parentNode.removeChild(li); reconcileMerkliste(); return; }
    write(remove(l, id));
    var hearts = document.querySelectorAll('[data-mt-wish][data-id="' + id + '"]');
    for (var h = 0; h < hearts.length; h++) syncButton(hearts[h], false);
    updateCount();
    li.className = 'pcard pcard--lp mtmk-karte mtmk-karte--undo';
    li.removeAttribute('aria-busy');
    li.innerHTML =
      '<div class="mtmk-undo-inner">' +
        '<span class="mtmk-undo-label">' + (IST_EN ? 'Removed' : 'Entfernt') + '</span>' +
        '<span class="mtmk-undo-title">' + escHtml(item.title || (IST_EN ? 'Item' : 'Artikel')) + '</span>' +
        '<button type="button" class="mtmk-undo-btn" data-mk-undo>' +
          '<svg class="mt-ic" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M23,24a1,1,0,0,1-1-1,6.006,6.006,0,0,0-6-6H10.17v1.586A2,2,0,0,1,6.756,20L0.877,14.121a3,3,0,0,1,0-4.242L6.756,4A2,2,0,0,1,10.17,5.414V7H15a9.01,9.01,0,0,1,9,9v7A1,1,0,0,1,23,24ZM8.17,5.414,2.291,11.293a1,1,0,0,0,0,1.414L8.17,18.586V16a1,1,0,0,1,1-1H16a7.984,7.984,0,0,1,6,2.714V16a7.008,7.008,0,0,0-7-7H9.17a1,1,0,0,1-1-1Z"/></svg>' +
          (IST_EN ? 'Undo' : 'Rückgängig') +
        '</button>' +
      '</div>';
    li.classList.add('mtmk-fade-in'); void li.offsetWidth; li.classList.remove('mtmk-fade-in');
    li._mkItem = item; li._mkIdx = idx;
    clearTimeout(undoTimers[id]);
    undoTimers[id] = setTimeout(function () { finalizeRemoval(li); }, 6000);
  }

  /* ---------- Sortierung ---------- */
  function priceCents(it) {
    if (it && PREIS[String(it.id)] != null) return PREIS[String(it.id)];
    if (it && typeof it.preis_ct === 'number') return it.preis_ct;
    var s = (it && it.price ? String(it.price) : '').replace(/[^0-9,.\-]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    var n = parseFloat(s);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  function getSortPref() { try { return window.localStorage.getItem('mt_wishlist_sort') || 'recent'; } catch (e) { return 'recent'; } }
  function setSortPref(v) { try { window.localStorage.setItem('mt_wishlist_sort', v); } catch (e) {} }
  function sortList(list) {
    var s = getSortPref(), a = list.slice();
    if (s === 'name') a.sort(function (x, y) { return (x.title || '').localeCompare(y.title || '', 'de'); });
    else if (s === 'price-asc') a.sort(function (x, y) { return priceCents(x) - priceCents(y); });
    else if (s === 'price-desc') a.sort(function (x, y) { return priceCents(y) - priceCents(x); });
    // GPT A32 (08.10.2026): Neue Einträge stehen im Speicher schon vorn (toggle: list.unshift). Für „Zuletzt hinzugefügt“ bleibt die
    // Speicherfolge deshalb, wie sie ist; das frühere a.reverse() zeigte den ältesten Eintrag zuerst.
    return a;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mt-wish]');
    if (btn) { e.preventDefault(); toggle(btn); return; }

    var rm = e.target.closest('[data-mk-remove]');
    if (rm) {
      e.preventDefault();
      var card = rm.closest('.mtmk-karte');
      if (card) removeWithUndo(card);
      return;
    }

    var undoBtn = e.target.closest('[data-mk-undo]');
    if (undoBtn) {
      e.preventDefault();
      var ucard = undoBtn.closest('.mtmk-karte');
      if (ucard && ucard._mkItem) {
        clearTimeout(undoTimers[ucard.getAttribute('data-id')]);
        restoreCard(ucard, ucard._mkItem, ucard._mkIdx);
      }
      return;
    }
  });

  function init() {
    syncAllButtons();
    updateCount();
    renderMerkliste();

    var sortSel = document.getElementById('mt-merkliste-sort');
    if (sortSel) {
      sortSel.value = getSortPref();
      // GPT A24-002 und A24-003 (08.10.2026): Am Desktop legt das Theme eine eigene Liste über das Feld (plugin-selects.js). Sie meldet
      // „change“, bevor sie den Wert setzt: sortiert wurde deshalb nach der vorigen Auswahl. Beim Laden zeigte sie „Select Option“,
      // weil keine Option das Attribut selected trug. Darum: Wert auch nach dem Klick lesen, Attribut selected und Beschriftung nachführen.
      var sortAnzeige = function () {
        try {
          var idx = sortSel.selectedIndex, o = sortSel.options[idx]; if (!o) return;
          for (var i = 0; i < sortSel.options.length; i++) { if (i === idx) sortSel.options[i].setAttribute('selected', ''); else sortSel.options[i].removeAttribute('selected'); }
          if (sortSel.selectedIndex !== idx) sortSel.selectedIndex = idx;
          var w = sortSel.parentNode ? sortSel.parentNode.querySelector('.bv_atual') : null; if (!w) return;
          var s = w.querySelector('.sl_inner'); if (s && s.textContent !== o.text) s.textContent = o.text;
          var lb = document.querySelector('label[for="mt-merkliste-sort"]');
          var nm = (lb ? lb.textContent.replace(/\s+/g, ' ').trim() + ': ' : '') + o.text;
          if (w.getAttribute('aria-label') !== nm) w.setAttribute('aria-label', nm);
        } catch (e) {}
      };
      var sortLetzte = sortSel.value;
      var sortWechsel = function () {
        sortAnzeige();
        if (sortSel.value === sortLetzte) return;
        sortLetzte = sortSel.value; setSortPref(sortSel.value); renderMerkliste();
      };
      sortSel.addEventListener('change', function () { sortWechsel(); setTimeout(sortWechsel, 0); setTimeout(sortWechsel, 80); });
      sortAnzeige(); setTimeout(sortAnzeige, 400); setTimeout(sortAnzeige, 1500); setTimeout(sortAnzeige, 4000);
    }

    // spaeter eingefuegte Buttons (Slider/Quick-View) nachsynchronisieren
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var k = 0; k < added.length; k++) {
          var n = added[k];
          if (n.nodeType === 1 && (n.matches && (n.matches('[data-mt-wish]') ||
            (n.querySelector && n.querySelector('[data-mt-wish]'))))) {
            syncAllButtons();
            return;
          }
        }
      }
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }

  // Kundenportal (19.10.2026): Zugriff für mt-portal.js. schreiben() übernimmt die abgeglichene Liste ohne neue Meldung.
  window.mtMerkliste = {
    lesen: read,
    schreiben: function (l) { STUMM = true; try { write(Array.isArray(l) ? l : []); } finally { STUMM = false; } syncAllButtons(); updateCount(); renderMerkliste(); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
